import { List, Map } from 'immutable';
import { put, select, takeEvery } from 'redux-saga/effects';

import { setAll } from 'redux/reducers/photos';
import { ADD_ORDER, SET_ORDERS } from 'redux/reducers/orders';

export function* fillFromOrder({ id }) {
  try {
    const order = yield select(state => state.getIn(['orders', id], Map()));
    const uploads = order.get('uploads', Map());

    if (uploads && uploads.count() > 0) {
      const orderPhotos = uploads.map((upload, simpleId) =>
        Map({
          simpleId: simpleId,
          exif: upload.get('exif', Map()).toJS(),
          exifId: upload.get('exifId'),
        })
      );

      yield put(setAll(id, orderPhotos.toList()));
    } else {
      yield put(setAll(id, List()));
    }
  } catch (e) {
    pe(e, 'failed setting photos from order');
  }
}

export function* fillFromOrders({ orders }) {
  const orderIds = Object.keys(orders);

  yield orderIds.map(orderId => fillFromOrder({ id: orderId }));
}

export default function* saga() {
  yield takeEvery(ADD_ORDER, fillFromOrder);
  yield takeEvery(SET_ORDERS, fillFromOrders);
}



// WEBPACK FOOTER //
// ./app/redux/sagas/moments.js